import Head from "next/head";
import dynamic from "next/dynamic";
import PageContextWrapper from "@components/Components/Reusables/PageContextWrapper";
import { getBrands } from "@components/config/helpers";

const Purchase = dynamic(() => import("../js/Components/Purchase/Purchase"));

//Dynamically load the purchase component and return it

const purchase = ({ data }) => {
    const meta = data.template_page_content.meta;

    return (
        <>
            <Head>
                <title>{meta.meta_title}</title>
                <meta
                    name="description"
                    content={meta.meta_description}
                />
            </Head>

            <PageContextWrapper
                page='purchase'
                page_content={data.template_page_content}
            >
                <Purchase {...data} />
            </PageContextWrapper>
        </>
    );
};

export async function getServerSideProps({ res }) {

    if (!getBrands(['ET'])) {
        return { notFound: true }
    }

    try {
        const req = await fetch(`${process.env.NEXT_PUBLIC_BASE_API_URL}purchase`);
        const data = await req.json();

        if (data.exception) {
            return { notFound: true }
        }

        return {
            props: {
                data
            },
        };
    } catch (error) {
        res.statusCode = 404;
        return {
            props: {}
        }
    }

}

export default purchase;
